export default "__VITE_ASSET__YraNTaOh__"